import * as React from "react";
import { UitkHeading, UitkHeadingProps, UitkText } from "uitk-react-text";
import { LobTitleProps } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";
import { Viewport, ViewMedium, ViewSmall } from "@shared-ui/viewport-context";

export const PackageLobTitle: React.FunctionComponent<LobTitleProps> = ({ lobState, pageHeading, pageSubHeading }) => {
  const { formatText } = useLocalization();
  const paddingUnlessShowAllSubLOB = !lobState.config.showAllSubLOB ? "all-b-padding-two" : "";
  const headingConfig: UitkHeadingProps = { level: 1, size: 700 };
  const heading = <UitkHeading {...headingConfig}>{pageHeading}</UitkHeading>;

  if (lobState.config.heading.hideLobTitle) {
    return null;
  }

  if (lobState.config.heading.differentiatedTitles) {
    return (
      <Viewport>
        <ViewMedium>
          <div className="uitk-type-display-700">{formatText(lobState.config.heading.locTitleDesktopTextToken)}</div>
        </ViewMedium>
        <ViewSmall>{heading}</ViewSmall>
      </Viewport>
    );
  }

  return (
    <div className={paddingUnlessShowAllSubLOB}>
      <UitkHeading {...headingConfig}>{pageHeading}</UitkHeading>
      {pageSubHeading && (
        <UitkText spacing="one" size={300}>
          {pageSubHeading}
        </UitkText>
      )}
    </div>
  );
};
